import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { AuthShell } from "./AuthShell";

export function ResetUnavailable() {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="reset-unavailable">
      <ShieldCheck className="h-6 w-6 text-emerald-500" />
      <p className="mt-3 font-medium text-slate-800">Self-service password reset isn't available yet.</p>
      <p className="mt-2 text-sm text-slate-500">
        Restaurant owners: please contact your platform administrator to reset your password.
        Staff: please ask your restaurant owner.
      </p>
    </div>
  );
}

export default function Forgot() {
  return (
    <AuthShell
      title="Reset password"
      footer={<Link to="/login" className="font-semibold text-emerald-600 hover:underline" data-testid="back-to-login">Back to sign in</Link>}
    >
      <ResetUnavailable />
    </AuthShell>
  );
}
